import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const provider = new GoogleAuthProvider();

async function ensureUserDoc(emailRaw) {
  const email = String(emailRaw || "").toLowerCase().trim();
  if (!email) return;

  const ref = doc(db, "users", email);
  const snap = await getDoc(ref);

  // Only create if missing; never overwrite admin flags.
  if (!snap.exists()) {
    await setDoc(ref, { email, admin: false });
  }
}

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, provider);

  // Create Firestore user doc on sign-in (if missing)
  await ensureUserDoc(result.user?.email);

  return result.user;
}

export async function signOutUser() {
  await signOut(auth);
}
